
<div class="media-recorder" [ngClass]="type">
  <div class="media-recorder-header">
    <h3 class="media-recorder-title">
      {{ titleLabel | translate }}
    </h3>
  </div>

  <div class="media-recorder-body">
    <h6 class="media-recorder-status-message">
      @switch (recordStrategy.status()) {
        @case (statuses.INIT) {
          {{ startLabel | translate }}
        }
        @case (statuses.RECORDING) {
          <div class="dot-indicator" [class.paused]="paused"></div>
          {{ (paused ? 'CHAT.paused' : 'CHAT.recording') | translate }}
          <div class="limit-time-block">
            {{ 'CHAT.limit' | translate }}
            {{ maxDuration | secondsToTime }}
          </div>
        }
        @case (statuses.FINISHED) {
          {{ readyLabel | translate }}
        }
      }
    </h6>

    <div class="video-container media-element" [ngClass]="videoLayoutControl.value" [class.hidden]="type === messageTypes.AUDIO_MESSAGE || recordStrategy.status() === statuses.FINISHED">
      <video #mediaElement class="video-js vjs-default-skin" playsinline></video>
    </div>

    @switch (recordStrategy.status()) {
      @case (statuses.FINISHED) {
        @switch (type) {
          @case (messageTypes.AUDIO_MESSAGE) {
            <audio class="media-element hidden-media" [src]="recordStrategy.recordDataUrl()" #recordedAudioElement></audio>
          }
          @default {
            <lib-recorded-video-message
              class="media-element"
              theme="primary"
              [src]="recordStrategy.recordDataUrl()"
              [videoShape]="videoLayoutControl?.value"
            [hidePlayButton]="true"></lib-recorded-video-message>
          }
        }
      }
      @default {
        @switch (type) {
          @case (messageTypes.VIDEO_MESSAGE) {
            @if (recordStrategy.deviceReady()) {
              <div class="video-layout-switcher">
                @for (item of videoLayoutOptions; track item) {
                  <button
                    class="video-layout-option"
                    mat-icon-button
                    aria-label="Video layout"
                    [class.selected]="videoLayoutControl.value === item.type"
                    (click)="setVideoLayout(item.type)">
                    <lib-icon [icon]="item.icon"></lib-icon>
                  </button>
                }
              </div>
            }
          }
        }
      }
    }
  </div>

  <div class="media-recorder-footer">
    @switch (recordStrategy.status()) {
      @case (statuses.RECORDING) {
        <button mat-icon-button class="record-button" aria-label="Reset recording" (click)="resetPlayer()">
          <lib-icon icon="trash"></lib-icon>
        </button>
        <button
          class="primary-button record-button pause-play-button"
          mat-flat-button
          (click)="toggleRecordingPause()">
          <div class="record-button-content">
            <lib-icon icon="play-pause"></lib-icon>
            <span class="record-timestamp">
              {{ recordStrategy.timestamp() | secondsToTime }}
              <span class="total">/ {{ maxDuration | secondsToTime }}</span>
            </span>
          </div>
        </button>
        <button class="primary-button record-button" mat-fab aria-label="Stop recording" (click)="stopRecording()">
          <lib-icon icon="stop"></lib-icon>
        </button>
      }
      @case (statuses.CONVERTING) {
      }
      @case (statuses.FINISHED) {
        <button mat-icon-button class="record-button" aria-label="Reset recording" (click)="resetPlayer()">
          <lib-icon icon="trash"></lib-icon>
        </button>
        @if ((type === messageTypes.AUDIO_MESSAGE ? recordedAudioElement?.nativeElement : recordedVideoElement?.videoElement?.plyr); as mediaRecorded) {
          <button
            class="primary-button record-button pause-play-button"
            mat-flat-button
            (click)="togglePlayPause(mediaRecorded)">
            <div class="record-button-content">
              <lib-icon [icon]="mediaRecorded.paused ? 'play' : 'pause'"></lib-icon>
              <span class="record-timestamp">
                {{ (mediaRecorded.paused ? recordStrategy.timestamp() : mediaRecorded.currentTime) | secondsToTime }}
              </span>
            </div>
          </button>
        }
        <button class="primary-button record-button" mat-fab aria-label="Send" (click)="emitMediaMessage()">
          <lib-icon icon="arrow-up"></lib-icon>
        </button>
      }
      @default {
        <button mat-flat-button class="primary-button record-button" (click)="startRecording()" [disabled]="!recordStrategy.deviceReady()">
          <div class="record-button-content">
            <lib-icon [icon]="icon"></lib-icon>
            {{ 'CHAT.start_recording' | translate }}
          </div>
        </button>
      }
    }

  </div>
</div>
